import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'shared-special-instructions',
    templateUrl: './special-instructions.shared.component.html',
    styleUrls: ['./special-instructions.shared.component.scss']
})
export class SpecialInstructionsComponent implements OnInit {
    @Input() public headerPaddingTop: OLO.Components.MARGIN_SIZE = 'lg';
    @Input() public headerPaddingBottom: OLO.Components.MARGIN_SIZE = 'lg';
    @Input() public headerMarginTop: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public headerMarginBottom: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public isExpanded: boolean = false;
    @Input() public value: string = '';
    @Input() public placeholder: string = 'Write a message / note for the kitchen here';

    @Output() public onChange: EventEmitter<OLO.Components.IPrevNextEvent> = new EventEmitter();
    @Output() public onToggle: EventEmitter<boolean> = new EventEmitter();

    constructor() { }

    ngOnInit(): void { }

    public handleOnChange($event: OLO.Components.IPrevNextEvent): void {
        this.onChange.emit($event);
    }

    public toggleCollapse(): void {
        this.isExpanded = !this.isExpanded;

        this.onToggle.emit(this.isExpanded);
    }
}
